import { GroupProps, MeshProps } from '@react-three/fiber'
import { useCallback, useEffect, useState } from 'react'
import { DoubleSide, Vector2 } from 'three'
import onPointerDownHandler from '../../../../c.managers/TerrainManager/scripts/onPointerDownHandler'
import TerrainTile from '../../../GameElements/classes/TerrainTile'
import GameElement from '../../../GameElements/GameElement/GameElement'

type InteractiveTileProps = {
  onHover: (hovered: boolean) => void
  onClick?: () => void
  allowInteraction: boolean
  isSelected?: boolean
  isActionable?: boolean
  isPath: boolean
  isAttachOrigin?: boolean
  isAttachDestination?: boolean
  coords: Vector2
}
const InteractiveTile = ({
  allowInteraction,
  isSelected,
  isActionable,
  onHover,
  onClick = () => {},
  onPointerDown,
  isPath,
  isAttachOrigin,
  isAttachDestination,
  coords,
  ...props
}: InteractiveTileProps & MeshProps) => {
  const [isHovered, setIsHovered] = useState<boolean>(false)

  const pointerOverHandler = useCallback(() => {
    if (allowInteraction) {
      setIsHovered(true)
    }
  }, [allowInteraction])

  useEffect(() => {
    if (allowInteraction) {
      onHover(isHovered)
    }
  }, [isHovered, allowInteraction])

  return (
    <GameElement
      elementClass={TerrainTile}
      name={`InteractiveTile_${coords.x}_${coords.y}`}
      userData={{ ...props.userData, coords }}
      onPointerDown={onPointerDownHandler}
    >
      <mesh
        {...props}
        rotation={[-Math.PI / 2, 0, 0]}
        onPointerOver={pointerOverHandler}
        onPointerOut={() => setIsHovered(false)}
        onClick={() => (isHovered ? onClick() : pointerOverHandler)}
        onPointerDown={onPointerDown}
      >
        <planeGeometry args={[1, 1, 1, 1]} />
        <meshLambertMaterial
          emissive={0x666666}
          side={DoubleSide}
          color={isPath ? 'green' : isHovered ? 'red' : isSelected ? 'yellow' : 'white'}
          transparent
          // opacity={isHovered || isSelected || isPath ? 0.75 : 0.25}
          opacity={0}
        />
      </mesh>
      {isActionable && isSelected && (
        <mesh {...props} rotation={[-Math.PI / 2, 0, -Math.PI / 4]}>
          <planeGeometry args={[1, 1, 1, 1]} />
          <meshLambertMaterial emissive={0x666666} side={DoubleSide} color={'purple'} transparent opacity={0.5} />
        </mesh>
      )}
      {isActionable && (
        <group {...(props as GroupProps)}>
          <mesh rotation={[-Math.PI / 2, 0, -Math.PI / 4]} position={[0, 0.01, 0]}>
            <planeGeometry args={[1, 1, 1, 1]} />
            <meshLambertMaterial
              emissive={0x666666}
              side={DoubleSide}
              color={isAttachOrigin || isAttachDestination ? 'blue' : 'purple'}
              transparent
              opacity={0.5}
            />
          </mesh>
        </group>
      )}
    </GameElement>
  )
}

export default InteractiveTile
